import { ADD_JOB_LISTING } from '../../endpoints';
import { JobListing } from '../../types/jobs';
import makeAuthenticatedRequest from '../base-api';

const postJobApi = async (payload: JobListing) => {
  try {
    const response = await makeAuthenticatedRequest(ADD_JOB_LISTING, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    const result = await response.json();

    if (!response.ok) {
      if (result.message) {
        throw new Error(result.message);
      } else {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
    }

    return result;
  } catch (error) {
    console.error('Add agent failed:', error);
    throw error;
  }
};

export { postJobApi };
